"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CurrencyUtils_1 = require("../../../../../utils/CurrencyUtils");
var ExchangerUtils_1 = require("../../../../../utils/ExchangerUtils");
var CalculatorEmailView = function () {
    var _a;
    var _b = (0, CalculatorContextInterface_1.useCalculatorContext)(), email = _b.email, setEmail = _b.setEmail, appOrder = _b.appOrder, payment = _b.payment, exchanger = _b.exchanger, defaultCurrency = _b.defaultCurrency;
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    var _d = (0, react_hook_form_1.useFormContext)(), register = _d.register, errors = _d.formState.errors, setValue = _d.setValue;
    var _e = (0, react_1.useState)(), value = _e[0], setEmailValue = _e[1];
    var _f = (0, react_1.useState)(), discount = _f[0], setDiscount = _f[1];
    var _g = (0, react_1.useState)(false), showEmailInfo = _g[0], setShowEmailInfo = _g[1];
    var _h = (0, react_1.useState)(false), showEmailDisc = _h[0], setShowEmailDisc = _h[1];
    (0, react_1.useEffect)(function () {
        var formNode = document.getElementById("react-calculator");
        if (formNode) {
            var value_1 = formNode.getAttribute('data-discount-value');
            var size = formNode.getAttribute('data-discount-size');
            if (value_1 && size) {
                setDiscount({
                    "value": parseInt(value_1),
                    "size": parseInt(size)
                });
            }
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (value) {
            axios_1.default.get("/app/order/email/".concat(value, "/"))
                .then(function (response) {
                //console.log(response.data);
                if (response.status == 200) {
                    setEmail(response.data);
                }
                else {
                    setEmail(undefined);
                }
            }).catch(function (error) {
                setEmail(undefined);
                // console.log("error", error);
            });
        }
        else {
            setEmail(undefined);
        }
    }, [value]);
    (0, react_1.useEffect)(function () {
        if (appOrder) {
            setEmailValue(appOrder.user_email);
            setValue('email', appOrder.user_email);
        }
    }, [appOrder]);
    function getPrice(value, currency_code) {
        if (exchanger) {
            return Math.ceil(((value) / ExchangerUtils_1.ExchangerUtils.conver(exchanger, currency_code)));
        }
    }
    return (react_1.default.createElement("div", { className: "__wrap-item" },
        react_1.default.createElement("div", { className: "__wrap-top-item" }, errors.email
            ? (react_1.default.createElement("div", { className: "__has-error" }, (_a = errors.email.message) === null || _a === void 0 ? void 0 : _a.toString()))
            : (react_1.default.createElement("div", { className: "__wrap-email-view" },
                react_1.default.createElement("span", { className: "__top-notification" }, t("calculator.email.input.caption")),
                react_1.default.createElement("span", { className: "__top-value" },
                    email ? email.discount : 0,
                    " %"),
                react_1.default.createElement("span", { className: "tooltip-email" },
                    react_1.default.createElement("img", { className: "__image-email-info ", onMouseMove: function () { return setShowEmailDisc(true); }, onMouseOut: function () { return setShowEmailDisc(false); }, src: "/images/app/info.svg" }))))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)("__input-icon-wrap-full", errors.email ? "__error" : "", email !== undefined && !(errors.email) && "__succeess") },
            react_1.default.createElement("input", __assign({}, register("email", {
                required: {
                    value: !!(payment === null || payment === void 0 ? void 0 : payment.required_email),
                    message: t("calculator.email.required.message")
                },
                pattern: {
                    value: /^\S+@\S+\.\S+$/,
                    message: t("calculator.email.error.format")
                },
                onChange: function (e) { setEmailValue(e.target.value); }
            }), { autoComplete: "off", placeholder: t("calculator.email.input.placeholder") }))),
        react_1.default.createElement("div", { className: "__wrap-bottom-item" },
            react_1.default.createElement("span", { className: "__bottom-notification" },
                react_1.default.createElement("span", { className: "", style: { marginLeft: "0" } },
                    react_1.default.createElement("span", { className: "tooltiptext-email", style: { marginLeft: "0", top: "30px" } }),
                    react_1.default.createElement("span", { onMouseMove: function () { return setShowEmailInfo(true); }, onMouseOut: function () { return setShowEmailInfo(false); }, className: "email-link" }, t("calculator.email.link.bottom"))))),
        showEmailInfo &&
            react_1.default.createElement("div", { className: "__wrap-bottom-item", style: { width: "100%", position: "relative" } },
                react_1.default.createElement("span", { className: "__bottom-notification_email" }, t("calculator.email.link.tooltip"))),
        showEmailDisc &&
            react_1.default.createElement("div", { className: "__wrap-bottom-item", style: { width: "100%", position: "relative" } },
                react_1.default.createElement("span", { className: "__bottom-notification_email" }, (email)
                    ? react_1.default.createElement(react_1.default.Fragment, null, email.next_discount
                        ? react_1.default.createElement(react_1.default.Fragment, null,
                            t("calculator.email.discount.caption", {
                                discount: email.next_discount,
                                value: getPrice(email.next_value, payment ? payment.currency_code : defaultCurrency)
                            }),
                            " ",
                            CurrencyUtils_1.CurrencyUtils.symbol(payment ? payment.currency_code : defaultCurrency))
                        : react_1.default.createElement(react_1.default.Fragment, null, t("calculator.email.no_more_discount.caption")))
                    : react_1.default.createElement(react_1.default.Fragment, null,
                        t("calculator.email.discount.caption", {
                            discount: discount === null || discount === void 0 ? void 0 : discount.size,
                            value: getPrice(discount ? discount.value : 0, payment ? payment.currency_code : defaultCurrency)
                        }),
                        " ",
                        CurrencyUtils_1.CurrencyUtils.symbol(payment ? payment.currency_code : defaultCurrency))))));
};
exports.default = CalculatorEmailView;
